import {useIntl} from 'react-intl'
import AverageAnalytics from '../component/sections/AverageAnalytics'
import AverageAnalyticsSub from '../component/sections/AverageAnalyticsSub'
import RateAnalytics from '../component/sections/RateAnalytics'
import TimeLineChart from '../component/components/timeLineChart'
import TotalRevenue from '../component/sections/TotalRevenue'
import NumberOfOrders from '../component/sections/NumberOfOrders'
/* import ReferralRevenue from '../component/sections/ReferralRevenue'
import ReferredOrders from '../component/sections/ReferredOrders' */
import {useGetAnalytics} from '../context/useGetAnalytics'
import {useState} from 'react'
import RecentTrx from '../component/sections/RecentTrx'

export default function Reports() {
  const intl = useIntl()
  const [period, setPeriod] = useState(3)
  const {data, isLoading} = useGetAnalytics(period)

  const periodText = () => {
    switch (period) {
      case 1:
        return intl.formatMessage({id: 'GLOBAL.IN_TODAY'})
      case 3:
        return intl.formatMessage({id: 'GLOBAL.IN_LAST_WEEK'})
      case 4:
        return intl.formatMessage({id: 'GLOBAL.IN_LAST_30_DAYS'})
      case 5:
        return intl.formatMessage({id: 'GLOBAL.IN_LAST_90_DAYS'})
      default:
        return ''
    }
  }

  return (
    <>
      <div className='d-flex justify-content-between align-items-center gap-10'>
        <div>
          <h3 className='fs-4 mb-0' style={{color: '#6C757D'}}>
            {intl.formatMessage({id: 'ANALYTICS.SUMMARY'})}{' '}
            <span style={{color: '#141413', fontWeight: 'normal'}}>
              {intl.formatMessage({id: 'ANALYTICS.SUMMARY.1'})}
            </span>{' '}
            {intl.formatMessage({id: 'ANALYTICS.SUMMARY.2'})}
          </h3>
        </div>
        <select
          className='form-select form-select-solid w-150px w-md-200px bg-white border-light'
          data-control='select2'
          data-placeholder='Select an option'
          data-hide-search='true'
          value={period.toString()}
          disabled={isLoading}
          onChange={(e) => {
            setPeriod(Number(e.target.value))
          }}
        >
          <option value='5'>{intl.formatMessage({id: 'GLOBAL.LAST_90_DAYS'})}</option>
          <option value='4'>{intl.formatMessage({id: 'GLOBAL.LAST_30_DAYS'})}</option>
          <option value='3'>{intl.formatMessage({id: 'GLOBAL.LAST_WEEK'})}</option>
          <option value='1'>{intl.formatMessage({id: 'GLOBAL.TODAY'})}</option>
        </select>
      </div>

      <div className='tab-content mt-5' id='myTabContent'>
        <div className='tab-pane fade active show' role='tabpanel'>
          <div className='card-body position-relative pt-0'>
            <div className='tab-content' id='myTabContent'>
              <AverageAnalytics
                member={data?.member}
                average={data?.average}
                period={periodText()}
              />
              <RateAnalytics rate={data?.rate} />
              <AverageAnalyticsSub point={data?.point} />
              <TimeLineChart revenue={data?.revenue} revenueTimeBand={data?.revenueTimeBand} />

              <div className='d-flex w-100  gap-10 flex-column flex-md-row my-5'>
                <div className='card w-100'>
                  <TotalRevenue revenue={data?.revenue} period={periodText()} />
                </div>

                <div className='card w-100'>
                  <NumberOfOrders order={data?.order} period={periodText()} />
                </div>
              </div>

              {/* <div className='d-flex w-100  gap-5 flex-column flex-md-row mt-5'>
                <div className='card w-100'>
                  <ReferralRevenue revenue={data?.revenue} />
                </div>

                <div className='card w-100'>
                  <ReferredOrders order={data?.order} />
                </div>
              </div> */}

              <div className='tab-pane fade active show' role='tabpanel'>
                <div className='card-body position-relative pt-0'>
                  <div className='tab-content' id='myTabContent'>
                    <div className='tab-pane fade active show' role='tabpanel'>
                      <div>
                        <div className='d-flex justify-content-between gap-5 mt-10'>
                          <div className='w-100'>
                            <RecentTrx
                              data={data?.transaction?.transactionData?.slice(0, 5) ?? []}
                              loading={false}
                            />
                            {/*  <div className='card w-100 p-5'>
                              <div className='fs-1 fw-bold text-primary mb-7'>
                                {intl.formatMessage({
                                  id: 'STORE.DETAIL.TRANSACTIONS.LAST_10',
                                })}
                              </div>
                              <div className='table-responsive'>
                                <table className='table table-bordered'>
                                  <thead>
                                    <tr
                                      className='fw-bold fs-6 text-gray-800'
                                      style={{
                                        backgroundColor: '#F3F0EE',
                                        borderTop: 'none',
                                      }}
                                    >
                                      <th>
                                        {intl.formatMessage({
                                          id: 'STORE.DETAIL.TRANSACTIONS.ORDER_ID',
                                        })}
                                      </th>
                                      <th>
                                        {intl.formatMessage({
                                          id: 'STORE.DETAIL.TRANSACTIONS.AMOUNT',
                                        })}
                                      </th>
                                      <th>
                                        {intl.formatMessage({
                                          id: 'STORE.DETAIL.TRANSACTIONS.DATE_TIME',
                                        })}
                                      </th>
                                      <th>
                                        {intl.formatMessage({
                                          id: 'STORE.DETAIL.TRANSACTIONS.TYPE',
                                        })}
                                      </th>
                                      <th>
                                        {intl.formatMessage({
                                          id: 'STORE.DETAIL.TRANSACTIONS.EARNED',
                                        })}
                                      </th>
                                      <th>
                                        {intl.formatMessage({
                                          id: 'STORE.DETAIL.TRANSACTIONS.REDEEMED',
                                        })}
                                      </th>
                                      <th>
                                        {intl.formatMessage({
                                          id: 'STORE.DETAIL.TRANSACTIONS.REWARD',
                                        })}
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {data?.transaction?.transactionData?.map((item, index) => (
                                      <tr key={index}>
                                        <td>{item.orderID}</td>
                                        <td>{item.amount}</td>
                                        <td>{new Date(item.dateAndTime).toLocaleString()}</td>
                                        <td>{item.type}</td>
                                        <td>{item.earned ? item.earned : ''}</td>
                                        <td>{item.redeemed ? item.redeemed : ''}</td>
                                        <td>{item.reward}</td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>

                                <div className='d-flex justify-content-between align-items-center py-5'>
                                  <div>
                                    <Dropdown
                                      tableDropdown={true}
                                      maxCount={5}
                                      setMaxCount={() => ''}
                                    />
                                  </div>
                                  <Pagination
                                    currentPage={1}
                                    setCurrentPage={() => ''}
                                    totalPages={1}
                                  />
                                </div>
                              </div>
                            </div> */}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
